import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";
import { useNavigate } from "react-router";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { AccessResult } from "utils/access";
import PermissionGateDropdownItem from "components/PermissionGate/DropdownMenuItem";

const TRIGGER_VERSION = gql`
  mutation TriggerVersion($moduleId: ID!, $id: ID!) {
    versionTrigger(module: $moduleId, id: $id) {
      id
    }
  }
`;

type TriggerAgainDropdownItemProps = {
  id: string;
  moduleId: string;
  canManageModule: AccessResult;
};

const TriggerAgainDropdownItem = ({
  id,
  moduleId,
  canManageModule,
}: TriggerAgainDropdownItemProps) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const navigate = useNavigate();

  const [triggerVersion, { loading }] = useMutation<{
    versionTrigger: { id: string };
  }>(TRIGGER_VERSION, {
    refetchQueries: ["GetModuleVersions"],
    variables: { moduleId, id },
  });

  const handleTrigger = async () => {
    try {
      const { data } = await triggerVersion();
      reportSuccess({ message: "Version triggered" });
      navigate(`/module/${moduleId}/version/${data?.versionTrigger.id}`);
    } catch (error) {
      onError(error);
    }
  };

  return (
    <PermissionGateDropdownItem
      isDisabled={loading}
      access={canManageModule}
      onAction={handleTrigger}
    >
      Trigger again
    </PermissionGateDropdownItem>
  );
};

export default TriggerAgainDropdownItem;
